import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { share } from 'rxjs/operators';

import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../environments/environment.dev';
import * as _ from 'lodash';
import { Router } from '@angular/router';

export enum AuthenticationStatus {
    PENDING = 'Pending',
    LOGGED_IN = 'Logged in',
    LOGGED_OUT = 'Logged out'
}

const ZONEIQ_AUTH_SERVICE = environment.ZONEIQ_AUTH_SERVICE + '/api/v1/auth';
const TOKEN_FIELD = 'token';

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService {
    private readonly statusSubject = new BehaviorSubject<AuthenticationStatus>(AuthenticationStatus.PENDING);
    public readonly status = this.statusSubject.asObservable().pipe(share());

    private get _router() { return this._injector.get(Router); }

    private token = this.loadToken();
    public getToken() {
        return this.token;
    }

    constructor(
        private readonly http: HttpClient,
        private readonly _injector: Injector,
        private readonly cookieService: CookieService,
    ) { }

    public loadToken() {
        const token = this.cookieService.get(TOKEN_FIELD);
        return token;
    }

    public logout() {
        const url = `${ZONEIQ_AUTH_SERVICE}/signout`;

        return this.http
            .get<object>(url)
            .subscribe(response => {
                this.removeToken();
                const umtServiceURL = _.get(response, 'data.umtServiceURL', '');
                if (umtServiceURL) {
                    window.location.assign(`${umtServiceURL}${this.getAuthServiceUrl()}/api/v1/authenticate?redirectUrl=${window.location.href}`);
                }
            });
    }

    public removeToken() {
        this.cookieService.delete(TOKEN_FIELD, '/', '.gridics.com');
    }

    public navigateToAccessDeniedPage() {
        this.statusSubject.next(AuthenticationStatus.LOGGED_OUT);
        this._router.navigate(['/access-denied'], { replaceUrl: true });
    }

    private getAuthServiceUrl() {
        return environment.ZONEIQ_AUTH_SERVICE.indexOf('http') === 0
            ? environment.ZONEIQ_AUTH_SERVICE
            : `${window.location.origin}/${environment.ZONEIQ_AUTH_SERVICE}`;

    }

    setIsAuthenticated(user) {

        this.statusSubject.next(!!_.get(user, 'Id') ? AuthenticationStatus.LOGGED_IN : AuthenticationStatus.PENDING);
    }
}
